export const CartelTab = ({ cartel, alt }: { cartel: string, alt: string }) => {
    return (
        <div className="col-span-6 pb-8">
            <img src={cartel} alt={alt} />
        </div>
    )
}